import { Fragment, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Renders its page under a key equal to one route param (`:id` by default).
 *
 * React Router reuses the element when only a param changes, so a detail A →
 * detail B navigation (a link to a sibling entity, browser back or forward)
 * would keep A's component alive: its `useState`, its localStorage-backed hooks
 * (read once, under A's keys) and its mount effects would carry over to B. The
 * key turns that navigation into a remount, so the page starts over for B.
 * Lives outside the route fragments so they keep exporting only route elements
 * (react-refresh constraint).
 */
export default function KeyedByParam({
  param = 'id',
  children,
}: {
  param?: string;
  children: ReactNode;
}) {
  const params = useParams();
  return <Fragment key={params[param] ?? ''}>{children}</Fragment>;
}
